import Helpers from './AddressVerificationHelpers';

/** @typedef {import("./types").Address} Address */
/** @typedef {import("./types").AddressInputSelectors} AddressInputSelectors */

class AddressForm {
  /**
   * @param {HTMLElement} $el
   * @param {AddressInputSelectors} inputSelectors
   */
  constructor($el, inputSelectors = Helpers.defaultAddressInputSelectors) {
    this.$el = $el;
    this.inputSelectors = inputSelectors;

    this.inputs = Helpers.getAddressInputsFromForm($el, inputSelectors);
  }

  getElement() {
    return this.$el;
  }

  getAddress() {
    return Helpers.getAddressFromInputs(this.inputs);
  }

  getAddressInputs() {
    return this.inputs;
  }

  /**
   * @param {Address} address
   */
  updateAddress(address) {
    Helpers.updateAddressInputValues(this.inputs, address);
  }

  getEmptyRequiredFormInputs() {
    return Helpers.getEmptyRequiredFormInputs(this.$el);
  }
}

export default AddressForm;



// WEBPACK FOOTER //
// ./V7/addressVerification/AddressForm.js